import * as React from 'react'

import ItemsListing from '../../../components/itemsListing'
import createSearchResultBodyContainer, {
  Props
} from '../../../containers/searchResultBodyContainer'

const SearchResultBody: React.SFC<Props> = ({
  matches,
  currentSite,
  viewType,
  location
}) => (
  <ItemsListing
    items={matches}
    location={location}
    currentSite={currentSite}
    viewType={viewType}
  />
)

export default createSearchResultBodyContainer(SearchResultBody)
